import { getCurrencySymbol } from '@/helpers/common'
import { numberFormat } from '@/helpers/numbers'

type TaxLotDateFields = {
  status: string
  close_date?: string | null
  as_of_date?: string | null
}

type TaxLotGainFields = {
  status: string
  realized_gain_loss?: number | null
  unrealized_gain_loss?: number | null
}

export const getTaxLotDisplayDate = (taxLot: TaxLotDateFields) =>
  taxLot.status === 'closed' ? taxLot.close_date : taxLot.as_of_date

export const getTaxLotGainLoss = (taxLot: TaxLotGainFields) =>
  taxLot.status === 'closed'
    ? taxLot.realized_gain_loss
    : taxLot.unrealized_gain_loss

export const formatTaxLotCurrencyAmount = (
  value: number | null | undefined,
  currency: string,
) => {
  if (value === null || value === undefined) return ''
  return numberFormat(value, {
    currency: getCurrencySymbol(currency),
  })
}
